import { render, staticRenderFns } from "./AdditionalFields.vue?vue&type=template&id=0f754039&scoped=true&"
import script from "./AdditionalFields.vue?vue&type=script&lang=js&"
export * from "./AdditionalFields.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFields.vue?vue&type=style&index=0&id=0f754039&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f754039",
  null
  
)

export default component.exports